interface RequestHistoryITF {
  name?: string;
  type?: string;
  status?: string;
  appId?: any;
  alias?: string;
}

export const getRequestHistoryByIdentity = async (
  identity: string,
  filter?: any,
  limit?: number,
  pageSize?: any,
) => {
  try {

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/history/${identity}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          identity,
          filter,
          limit,
          pageSize,
        }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const createRequestHistory = async (
  payload: any
) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/history`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const updateRequestHistory = async (
  id: string,
  payload: RequestHistoryITF
) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/history`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, payload }),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};
